module.exports = __webpack_public_path__ + "img/logo.8459c6b5.png";